<template>
	<div class="page-zhuanti" :style="'background-color:'+bgColor">
		<div class="content" :style="is_comment ? 'padding-bottom: 2rem' : 'padding-bottom: .6rem' ">
			<div class="content-item" v-for="(item,index) in zhuantiData" :key="index">
				<div class="con-section" v-if="item.type_id == 1">	
					<div class="ymweapp-wrap" v-if="item.content.link_type == 2 || item.content.link_type == 3 || item.content.link_type == 4 || item.content.link_type == 5">
						<div class="">
							<img :src="imageUrl+item.content.thumb" alt="" class="">
						</div>
						<wx-open-launch-weapp id="ymweapp" :username="item.content.link_type == 2 ? 'gh_ac3aa3211774' : item.content.link_type == 3 ? 'gh_13d4df09e5c2' : item.content.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="item.content.link? item.content.link : 'pages/index/index'">
							<script type="text/wxtag-template">
								<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
								<div class="ymweapp-tu"></div>
							</script>
						</wx-open-launch-weapp>
					</div>
					<div class="" v-else @click="linkFun(item.content)">
						<img :src="imageUrl+item.content.thumb" alt="" class="">
					</div>
				</div>
				<div class="con-section" v-if="item.type_id == 2" @click="showVideoFun(item)">
					<img :src="imageUrl+item.content.thumb" alt="" class="poster-img">
					<!-- <video style="width:100%;" controls :src="imageUrl+item.content.link" :poster="imageUrl+item.content.thumb"></video> -->
				</div>
				<div class="con-section" v-if="item.type_id == 4">
					<div class="goods-list">
						<div class="goods-item" v-for="(goods,index) in item.content" :key="index">
							<div class="ymweapp-wrap" v-if="goods.link_type == 2 || goods.link_type == 3 || goods.link_type == 4 || goods.link_type == 5">
								<div class="">
									<img :src="imageUrl+goods.thumb" alt="" class="">
								</div>
								<wx-open-launch-weapp id="ymweapp" :username="goods.link_type == 2 ? 'gh_ac3aa3211774' : goods.link_type == 3 ? 'gh_13d4df09e5c2' : goods.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="goods.link? goods.link : 'pages/index/index'">
									<script type="text/wxtag-template">
										<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
										<div class="ymweapp-tu"></div>
									</script>
								</wx-open-launch-weapp>
							</div>
							<div class="" v-else @click="linkFun(goods)">
								<img :src="imageUrl+goods.thumb" alt="" class="">
							</div>
						</div>
					</div>
				</div>
				<div class="con-section" v-if="item.type_id == 5">
					<div class="yuekan-list">
						<div class="yuekan-item" v-for="(yuekan,index) in item.content" :key="index">
							<div class="ymweapp-wrap" v-if="yuekan.link_type == 2 || yuekan.link_type == 3 || yuekan.link_type == 4 || yuekan.link_type == 5">
								<div class="">
									<img :src="imageUrl+yuekan.thumb" alt="" class="">
								</div>
								<wx-open-launch-weapp id="ymweapp" :username="yuekan.link_type == 2 ? 'gh_ac3aa3211774' : yuekan.link_type == 3 ? 'gh_13d4df09e5c2' : yuekan.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="yuekan.link? yuekan.link : 'pages/index/index'">
									<script type="text/wxtag-template">
										<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
										<div class="ymweapp-tu"></div>
									</script>
								</wx-open-launch-weapp>
							</div>
							<div class="" v-else @click="linkFun(yuekan)">
								<img :src="imageUrl+yuekan.thumb" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="con-seciont" v-if="item.type_id == 3">
					<div class="tab-wrap">
						<div :class=" item.currentCateId == fenlei.cate_id ? 'tab-item active' : 'tab-item'" v-for="(fenlei,tabIndex) in item.cate" :key="tabIndex" @click="selectCateIdFun(item.block_id,fenlei.cate_id)">{{ fenlei.content }}</div>
					</div>
					<div class="content-item" v-for="(secItem,index) in item.currentCate" :key="index">
						<div class="con-section" v-if="secItem.type_id == 1">
							<div class="ymweapp-wrap" v-if="secItem.content.link_type == 2 || secItem.content.link_type == 3 || secItem.content.link_type == 4 || secItem.content.link_type == 5 ">
								<div class="">
									<img :src="imageUrl+secItem.content.thumb" alt="" class="">
								</div>
								<wx-open-launch-weapp id="ymweapp" :username="secItem.content.link_type == 2 ? 'gh_ac3aa3211774' : secItem.content.link_type == 3 ? 'gh_13d4df09e5c2' : secItem.content.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="secItem.content.link? secItem.content.link : 'pages/index/index'">
									<script type="text/wxtag-template">
										<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
										<div class="ymweapp-tu"></div>
									</script>
								</wx-open-launch-weapp>
							</div>
							<div class="" v-else @click="linkFun(secItem.content)">
								<img :src="imageUrl+secItem.content.thumb" alt="" class="">
							</div>
						</div>
						<div class="con-section" v-if="secItem.type_id == 2">
							<img :src="imageUrl+secItem.content.thumb" alt="" class="poster-img" @click="showVideoFun(secItem)">
							<!-- <video style="width:100%;" controls :src="imageUrl+secItem.content.link" :poster="imageUrl+secItem.content.thumb"></video> -->
						</div>
						<div class="con-section" v-if="secItem.type_id == 4">
							<div class="goods-list">
								<div class="goods-item" v-for="(goods,index) in secItem.content" :key="index">									
									<div class="ymweapp-wrap" v-if="goods.link_type == 2 || goods.link_type == 3 || goods.link_type == 4 || goods.link_type == 5">
										<div class="">
											<img :src="imageUrl+goods.thumb" alt="" class="">
										</div>
										<wx-open-launch-weapp id="ymweapp" :username="goods.link_type == 2 ? 'gh_ac3aa3211774' : goods.link_type == 3 ? 'gh_13d4df09e5c2' : goods.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="goods.link? goods.link : 'pages/index/index'">
											<script type="text/wxtag-template">
												<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
												<div class="ymweapp-tu"></div>
											</script>
										</wx-open-launch-weapp>
									</div>
									<div class="" v-else @click="linkFun(goods)">
										<img :src="imageUrl+goods.thumb" alt="" class="">
									</div>
								</div>
							</div>
						</div>
						<div class="con-section" v-if="secItem.type_id == 5">
							<div class="yuekan-list">
								<div class="yuekan-item" v-for="(yuekan,index) in secItem.content" :key="index">
									<div class="ymweapp-wrap" v-if="yuekan.link_type == 2 || yuekan.link_type == 3 || yuekan.link_type == 4 || yuekan.link_type == 5">
										<div class="">
											<img :src="imageUrl+yuekan.thumb" alt="" class="">
										</div>
										<wx-open-launch-weapp id="ymweapp" :username="yuekan.link_type == 2 ? 'gh_ac3aa3211774' : yuekan.link_type == 3 ? 'gh_13d4df09e5c2' : yuekan.link_type == 4 ? 'gh_c4d2ea12156e' : 'gh_0e1240455bda' " :path="yuekan.link? yuekan.link : 'pages/index/index'">
											<script type="text/wxtag-template">
												<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
												<div class="ymweapp-tu"></div>
											</script>
										</wx-open-launch-weapp>
									</div>
									<div class="" v-else @click="linkFun(yuekan)">
										<img :src="imageUrl+yuekan.thumb" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 评论区 -->
			<div class="comment-wrap" v-if="is_comment && commentData.length">
				<div class="comment-con">
					<div class="comment-item" v-for="(comment,index) in commentData" :key="index">
						<div class="item-l">
							<img :src="comment.userdata.thumb  ? ($publicData.withHttpStart(comment.userdata.thumb) ? comment.userdata.thumb : imageUrl + comment.userdata.thumb) : $publicData.defaultTouxiang" alt="" class="user-thumb">
						</div>
						<div class="item_r">
							<div class="user_name">{{ comment.userdata.nickname }}</div>
							<div class="fir-commtent">
								<div class="comment-text" @click="toCommentFirFun(comment)">{{ comment.content }}</div>
								<div class="comment-time">{{ comment.created_at }}</div>
							</div>
							<div class="sec-comment" v-for="(secComment,index) in comment.s_comment" :key="index">
								<div class="comment-text">{{ secComment.userdata.nickname +": "+secComment.content }}</div>
							</div>		
						</div>
					</div>
				</div>
				<div class="comment-more" @click="loadMoreFun">{{ finished ? '没有更多了' : '更多评论' }}</div>
			</div>
		</div>
		<!-- 发布评论 -->
		<div class="comment-publish" v-if="is_comment">
			<div class="publish-l">
				<van-field v-model="content" :placeholder="placeholderText" ref="fieldDom" />
			</div>
			<div class="publish-btn" @click="publishFun">
				<img :src="this.publicPath+'statics/images/shop/pinglun_btn.png'" class="" alt="">
			</div>
		</div>
		<!-- 遮罩 -->
		<van-overlay :show="showVideoPop" >
			<van-icon name="close" class="custom-icon-close" @click="closeVideoModal" />
			<div class="play-video" :id="playerId" :style="playStyle"></div>
		</van-overlay>
	</div>
</template>
<script>
import openWeapp from "./../../../component/openweapp/index.vue"
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
	name: "zhuanti-detail",
	data(){
		return {
			id: this.$route.query.id, // 专题id 3
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token:null,
			bgColor: "", // 背景色,默认是白色
			zhuantiData: null, 
			page: 1,
			size: 2,
			content: "", // 评论内容
			is_comment: 0, // 是否开启评论 1是 0否
			commentData: [], // 评论列表
			parentid: null, // 一级评论id
			placeholderText: "请输入评论内容",
			finished: false, // 评论全部加载完
			domain: this.$publicData.domain,
			showVideoPop: false,
			currentVideoUrl: "", // video播放地址
			playerId: 'aliplayer_' +
                    Math.random()
                        .toString(36)
                        .substr(2),
			playStyle: {
				height: '5.3rem', // 40vh
				display: 'none'
			},
			player: null,   // 初始化的播放器
			instance: null,
			shareConfig: null, // 分享配置
			share_title: "", // 自定义标题
			share_thumb: "", // 自定义图标
			share_describe: "" // 自定义描述
		}
	},
	components: {
		openWeapp,
	},
	created() {
		if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '专题'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }
	},
	mounted() {
		// this.$nextTick(() => {
        //     // 播放完毕自动关闭弹窗
        //     const eleVideo = document.querySelector(".play-video");
        //     eleVideo.addEventListener("ended", () => {
        //         this.closeVideoModal();
        //     }, false);
        // });
	},
	methods: {
		// 专题详情
		getData(){
			let params = {
				zhuanti_id: this.id
			}
			this.$api.zhuanti.detail(params).then(res=>{
				if(res.code == 200){
					this.is_comment = res.result.is_comment;
					this.bgColor = res.result.background_color;
					let list = res.result.blocklist;
					for(let i in list){
						let item = list[i];
						if(item.type_id == 3){
							let cate = item.cate;
							for(let j in cate){	
								let second = cate[j].second;
								for(let k in second){
									second[k].content = JSON.parse(second[k].content)
								};
								if(j == 0){
									item.currentCateId = cate[j].cate_id;
									item.currentCate = second;
								};
							}
						}else{
							item.content = JSON.parse(item.content);
						}
					};
					this.zhuantiData = list;
					// console.log("详情",this.zhuantiData)
					if(this.is_comment){
						this.getCommentlist('init')
					};
					// 自定义的分享信息(未配置会取默认的)
					this.share_title = res.result.share_title || this.$publicData.shareDefaultTitleA;
					this.share_describe = res.result.share_describe || this.$publicData.shareDefaultTitleB;
					this.share_thumb = res.result.share_thumb ? this.imageUrl+res.result.share_thumb : this.$publicData.domain + this.$publicData.shareDefaultIcon;
					this.getShareData();
				}
			})
		},
		// 点选分类
		selectCateIdFun(block_id,cate_id){
			// console.log("参数",block_id,cate_id);
			let list = this.zhuantiData;
			for(let i in list){
				let item = list[i];
				if(item.block_id == block_id){
					if(item.type_id == 3 ){
						let cate = item.cate;
						for(let j in cate){	
							if(cate[j].cate_id == cate_id){
								item.currentCateId = cate_id;
								item.currentCate = cate[j].second;
							}
						}
					}
				}
			}
		},
		// 评论列表
		getCommentlist(init){
			if(init){
				this.page = 1;
				this.finished = false;
				this.commentData =  [];
			}
			let params = {
				zhuanti_id: this.id,
				page: this.page,
				size: this.size
			}
			this.$api.zhuanti.commentlist(params).then(res=>{
				if(res.code == 200){
					let list = res.result.list;
					if(list && list.length){
						this.commentData = this.commentData.concat(list);
						if(list.length < this.size){
							this.finished = true;
						}
					}else{
						this.finished = true;
					}
				}
			})
		},
		// 发表评论
		publishFun(){
			if(!this.content){
				this.$toast("请输入评论内容")
				return
			};
			let params = {
				token: this.token,
				zhuanti_id: this.id,
				content: this.content
			}
			if(this.parentid){
				params.parentid = this.parentid
			}
			this.$api.zhuanti.createcomment(params).then(res=>{
				if(res.code == 200){
					this.content = "";
					this.placeholderText = "";
					this.parentid = null;
					// 更新第一页的评论
					this.getCommentlist('init');
				}
			})
		},
		// 加二级评论
		toCommentFirFun(comment){
			this.parentid = comment.comment_id;
			this.placeholderText = "回复:"+comment.userdata.nickname;
			this.$refs.fieldDom.focus();
		},
		// 加载二级评论
		loadMoreFun(){
			if(this.finished){
				return;
			}else{
				this.page++;
				this.getCommentlist();
			}
		},
		// 跳转链接
		linkFun(item){
			// 类型 1H5 2定制 3盲盒 4商城 5非遗地图
			// console.log("item",item)
			// H5
			let linkUrl = "";
			if(item.link_type){
				if(item.link_type == 1){	
					console.log("H5")
					if(item.link){
						linkUrl = item.link;
					}else{
						linkUrl = this.domain
					}
					window.open(linkUrl)
				}else{
					// this.$toast("小程序");
					console.log("小程序不在这处理");
				}
			};
		},
		// 视频播放
		showVideoFun(item){
			this.showVideoPop = true;
			this.currentVideoUrl = item.content.link;
			// 初始化播放器
            this.setPlayer();
		},
		// 视频播放完
		closeVideoModal(){
			// console.log("关闭====")
			this.showVideoPop = false;
			// 销毁播放器(只暂停不销毁,会出现多层播放器;对于当前页面的场景,多个视频会有问题)
			this.instance.dispose();
		},
		// 播放器
		setPlayer() {
			var that = this
			that.playStyle.display = 'block';
			that.instance = new Aliplayer({
				id: that.playerId,
				source: that.imageUrl+that.currentVideoUrl,
				width: '100%',
				height: that.playStyle.height,
				autoplay: true,
				isLive: false,
				rePlay: false,
				playsinline: true,
				preload: true,
				controlBarVisibility: "hover",
				useH5Prism: true,
				skinLayout: [
					{
						name: "bigPlayButton",
						align: "blabs",
						x: 30,
						y: 80
					},
					{
						name: "H5Loading",
						align: "cc"
					},
					{
						name: "infoDisplay"
					},
					{
						name: "tooltip",
						align: "blabs",
						x: 0,
						y: 56
					},
					{
						name: "thumbnail"
					},
					{
						name: "controlBar",
						align: "blabs",
						x: 0,
						y: 0,
						"children": [
							{
								"name": "progress",
								"align": "blabs",
								"x": 0,
								"y": 44
							},
							{
								"name": "playButton",
								"align": "tl",
								"x": 15,
								"y": 12
							},
							{
								"name": "timeDisplay",
								"align": "tl",
								"x": 10,
								"y": 7
							},
							{
								"name": "fullScreenButton",
								"align": "tr",
								"x": 10,
								"y": 12
							},
							{
								"name": "volume",
								"align": "tr",
								"x": 5,
								"y": 10
							}
						]
					}
				],
				x5LandscapeAsFullScreen: false,
				// x5_type:'h5',
				showBarTime: 5000,
				controlBarVisibility: "always",
				x5_fullscreen: true,
				x5_video_position: "top",
				// "x5_orientation":"landscape",
			},
				function (player) {
					that.player = player;
					console.log('The player is created');
					// $('.prism-volume').before("<i class='control_btn'></i>");
					$("video").attr('x5-video-player-type', 'h5');    
					player.on("error", function (e) {
						$(".prism-ErrorMessage").hide();
						player.show_video = true;
					});
					// 播放结束
					player.on("ended", function(e){
						that.showVideoPop = false;
						console.log("播放结束")
					})
				
				}
			);
			
		},
		// 获取分享参数
		getShareData() {
            const url = location.href.split('#')[0];
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    this.shareFun()
                }
            })
        },
		// 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
				openTagList: that.shareConfig.openTagList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.share_title, // 分享标题
                    desc: that.share_describe, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.share_thumb, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
	},
}
</script>
<style scoped>
	.play-video{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
	/deep/.prism-player .prism-controlbar{
		top: unset !important;
	}
	.custom-icon-close{
		font-size: .6rem;
		color: #ffffff;
		position: absolute;
		top: .4rem;
		right: .4rem;
	}
	.ymweapp-wrap{
		position: relative;
	}
	.ymweapp-wrap #ymweapp{
		width:100%;
		height:100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	img{
		display: block;
	}
</style>